'use client'
import Image from 'next/image'
import styles from './styles.module.css'

const IMAGES = [
    '/images/idea-1.png',
    '/images/idea-2.png',
    '/images/idea-3.png',
]

// Each slot: front (active), mid, back
const SLOTS = [
    {
        width: 360,
        height: 360,
        top: '55%',
        left: '38%',
        zIndex: 3,
        filter: 'brightness(1)',
        overlay: 0,
    },
    {
        width: 210,
        height: 210,
        top: '54%',
        left: '59%',
        zIndex: 2,
        // filter: 'brightness(0.82) blur(1.5px)',
        filter: 'brightness(0.82)',
        overlay: 0.3,
    },
    {
        width: 175,
        height: 175,
        top: '77%',
        left: '51%',
        zIndex: 1,
        // filter: 'brightness(0.72) blur(2px)',
        filter: 'brightness(0.72)',
        overlay: 0.7,
    },
]

export default function IdeaImages({ activeIndex }) {
    // activeIndex is 1-based (1, 2, 3) or null — default to first image in front
    const active = activeIndex != null ? activeIndex - 1 : 0

    return (
        <div className={styles.container}>
            {IMAGES.map((src, i) => {
                const slotIndex = (i - active + 3) % 3
                const slot = SLOTS[slotIndex]

                return (
                    <div
                        key={i}
                        className={styles.imageItem}
                        style={{
                            width: slot.width,
                            height: slot.height,
                            top: slot.top,
                            left: slot.left,
                            zIndex: slot.zIndex,
                            filter: slot.filter,
                        }}
                    >
                        <Image
                            src={src}
                            alt={`idea-${i + 1}`}
                            fill
                            style={{ objectFit: 'cover' }}
                        />
                        {slot.overlay > 0 && (
                            <div className={styles.imageOverlay} style={{ opacity: slot.overlay }} />
                        )}
                    </div>
                )
            })}
        </div>
    )
}
